require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-chief-operations-officer-elected-to-credit-union-center-board.json") })
        }
      }, "path---es-articles-chief-operations-officer-elected-to-credit-union-center-board");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-chief-operations-officer-elected-to-credit-union-center-board!./.cache/json/es-articles-chief-operations-officer-elected-to-credit-union-center-board.json
// module id = 2077
// module chunks = 231608221292675